// extracted by mini-css-extract-plugin
export default {"Header__Section":"Header_Header__Section__6ncC1","Main__Title":"Header_Main__Title__Eh6Pm","Description":"Header_Description__iFkjT","Header__Image":"Header_Header__Image__O6tA7"};